import * as React from 'react';
import { AxiosError } from 'axios';

import { Auth } from '../auth/auth.component';
import { resultMessage, errorIcon } from '../payment-page.component.styles';
import { InvoiceAuthModel } from '../../../../models/invoice-auth.model';
import { Merchant } from '../../../../models/merchant.model';
import { MerchantContactInfo } from '../../../merchant-contact-info/merchant-contact-info.component';
import { ReactComponent as ErrorIcon } from '../../../../images/wv-icon-circle-x.svg';

const errorMessages: { [codeId: number]: { header: string; body: string } } = {
  0: {
    header: 'Whoops!',
    body:
      'An error occurred. Please try again. If you continue to get this message, please request a new link.',
  },
  20: {
    header: 'Hmmmm...',
    body:
      'A payment has already been made using this link. To make another payment, please request a new link.',
  },
  21: {
    header: 'Shoot!',
    body: 'This link has expired. To make a payment, please request a new link.',
  },
  22: {
    header: 'Oops!',
    body:
      'Too many authentication attempts were made. This link has been locked for security reasons. To make a payment, please request a new link.',
  },
  99: {
    header: 'Aw Shucks',
    body:
      'Sorry for the inconvenience. We know you want to pay your bill but there was an error. Please contact the sender so they can resolve it.',
  },
};

interface Props {
  auth: InvoiceAuthModel;
  uniqueLink: string;
  merchant?: Merchant;
  error: AxiosError;

  getInvoice: (uniqueCode: string, birthdate: string) => void;
}

export const ErrorComponent = (props: Props) => {
  if (props.auth.required) {
    return (
      <Auth
        auth={props.auth}
        merchant={props.merchant}
        uniqueLink={props.uniqueLink}
        getInvoice={props.getInvoice}
      />
    );
  }

  const getErrorMessage = () => {
    try {
      return errorMessages[props.error.response!.data.error.codeId] || errorMessages[0];
    } catch {
      return errorMessages[0];
    }
  };

  const errorMessage = getErrorMessage();
  return (
    <div className={resultMessage}>
      <h1>{errorMessage.header}</h1>
      <p>
        {errorMessage.body}
        <MerchantContactInfo merchant={props.merchant} />
      </p>
      <ErrorIcon className={errorIcon} />
    </div>
  );
};
